import httpClient from "../httpClient";
import { API_GROUP_DELETE } from "../config";

const deleteGroup = {
    delete: (id) => httpClient.delete(API_GROUP_DELETE + '/' + id),
};

export default deleteGroup;